module.exports = __webpack_public_path__ + "s.no2.76b55839.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/s.no2.jpg
// module id = En6R
// module chunks = 0